/* eslint-disable*/
// eslint-disable-next-line no-restricted-globals
import {
	Checkbox,
	ClickAwayListener,
	FormControlLabel,
	FormGroup,
	Grid,
	IconButton,
	Menu,
	Typography,
} from '@mui/material';
import { useTheme } from '@mui/styles';
import {
	addDays,
	addYears,
	differenceInCalendarDays,
	endOfDay,
	endOfYear,
	isSameDay,
	startOfDay,
	startOfMonth,
	startOfYear,
} from 'date-fns';
import moment from 'moment';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { useEffect, useRef, useState } from 'react';
import { DateRangePicker } from 'react-date-range';
import { useLocation } from 'react-router-dom';

import CalendarIcon from '../../assets/Images/CalendarIcon.svg';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { DateTimeFormatter } from '../../utils/DateFormatter';
import useLocalStorage from '../../utils/localStorage';
import { AppUtilityFunctions } from '../../utils/appUtils';
import Button from '../Button/Button';
import Dropdown from '../Dropdown/Dropdown';
import { IDateRange } from './IDateRangePicker';
import { IDatePickerProps, IRangePickerFormats } from './IDateRangePicker';

import './ReactDateRangePicker.scss';
import 'react-date-range/dist/styles.css';
// main css file
import 'react-date-range/dist/theme/default.css';
import { useDateRange } from './DateRangeContext';

const ReactDatePicker: React.FC<IDatePickerProps> = (props: any) => {
	const { width } = useWindowDimensions();
	const theme: any = useTheme();
	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);
	// In some reports there is not enough space for full format. hence, MMM is used.
	const format =
		width > 1280
			? IRangePickerFormats.range_med
			: IRangePickerFormats.range_responsive;
	const selectedDefaultMonths = props.defaultMonths
		? props.defaultMonths
		: AppUtilityFunctions.isFreemiumUser()
			? 24
			: 6;
	const [showComparison, setShowComparison] = useState(
		// !!useLocalStorage.getItem('date_comparison')
		!!props?.showComparison
	);
	const [inputRange, setInputRange] = useState([]);
	const [isCompared, setIsCompared] = useState(
		useLocalStorage.getItem('date_comparison') || false
	);
	const { dateRange: dateRangeContext, setDateRange: setDateRangeContext } = useDateRange() || {};
	let [saveDateForLabel, setSaveDateforLabel]: any = useState({
		startDate: '',
		endDate: '',
	});
	// Default Range
	const [displayDate, setDisplayDate] = useState({
		startDate: moment().subtract(selectedDefaultMonths, 'months').toDate(),
		endDate: new Date(),
	});
	// const minYear = props.minLastYear ?? 2;
	const minYear = 4;

	const [isPreviousYear, setIsPreviousYear]: any = useState(true);
	const [isMainCustom, setIsMainCustom] = useState(
		useLocalStorage.getItem('isCustomRange') === true ||
		useLocalStorage.getItem('isCustomRange') === 'true'
	);
	const [focusedRange, setFocusedRange]: any = useState([0, 0]);
	const [shownDate, setShownDate] = useState(
		moment().subtract(selectedDefaultMonths, 'months').toDate()
	);
	const [isDateApplied, setIsDateApplied] = useState(false);
	const [comparisionDisplayDate, setComparisonDisplayDate] = useState({
		startDate: moment()
			.subtract(selectedDefaultMonths * 2, 'months')
			.toDate(),
		endDate: moment().subtract(selectedDefaultMonths, 'months').toDate(),
	});

	const [applyButtonDisable, setApplyButtonDisable] = useState(true);
	const [isMultipleRange, setIsMultipleRange] = useState(
		!!props?.isMultipleRanges
	);
	const [showSideCalendar, setShowSideCalendar] = useState(false);
	const defaultDate: any = useRef({});
	const isPresetClicked = useRef(false);
	const isPickerEditing = useRef(false);
	let [forMetricReportComp, setForMetricReportComp] = useState('');

	const today = new Date();
	const lastSixMonthsStart = moment(today).subtract(6, 'months').toDate();
	const thisQuarterStart = moment(today).startOf('quarter').toDate();
	const lastQuarterStart = moment(today)
		.subtract(1, 'quarter')
		.startOf('quarter');
	const lastQuarterEnd = moment(today).subtract(1, 'quarter').endOf('quarter');
	const lastNinetyDaysStart = moment(today).subtract(90, 'days').toDate();
	const lastTwoYearsStart = moment(today).subtract(24, 'months').toDate();
	const allTimeStart = (() => {
		const start = new Date(today);
		start.setFullYear(start.getFullYear() - 4);
		start.setDate(start.getDate() + 1);
		return start;
	})();

	var lastyear: any = new Date(
		new Date().getFullYear() - 1,
		new Date().getMonth(),
		new Date().getDate()
	).getFullYear();

	const customRanges = (() => {
		const formatMonthYear = (date: any) => moment(date).format('MMM,YYYY');
		const buildRange = (
			label: string,
			rangeBuilder: any,
			options: any = {}
		) => ({
			label,
			...options,
			range: rangeBuilder,
			hasCustomRendering: true,
			isSelected(range: any) {
				if (range.key !== 'selection1') {
					return false;
				}
				if (options.uniqueKey === 'custom_range') {
					return isMainCustom;
				}
				if (options.uniqueKey === 'compare_control') {
					return false;
				}
				if (isMainCustom) {
					return false;
				}
				const definedRange: any = this.range();
				return (
					isSameDay(range.startDate, definedRange.startDate) &&
					isSameDay(range.endDate, definedRange.endDate)
				);
			},
		});

		const tempRanges: any = [];
		tempRanges.push(
			buildRange('This Week', () => ({
				startDate: firstDayOfWeek(new Date(), 0),
				endDate: new Date(),
			})),
			buildRange('Last Week', () => ({
				startDate: moment(firstDayOfWeek(new Date(), 0))
					.subtract(7, 'days')
					.toDate(),
				endDate: moment(firstDayOfWeek(new Date(), 0))
					.subtract(7, 'days')
					.add(6, 'days')
					.toDate(),
			})),
			buildRange('This Month', () => ({
				startDate: moment().startOf('month').toDate(),
				endDate: new Date(),
			})),
			buildRange('Last Month', () => ({
				startDate: moment().subtract(1, 'month').startOf('month').toDate(),
				endDate: moment().subtract(1, 'month').endOf('month').toDate(),
			})),
			buildRange(
				`Last 6 Months (${formatMonthYear(
					lastSixMonthsStart
				)} - ${formatMonthYear(today)})`,
				() => ({
					startDate: moment().subtract(6, 'months').toDate(),
					endDate: new Date(),
				})
			),
			buildRange('This Quarter', () => ({
				startDate: thisQuarterStart,
				endDate: moment().endOf('quarter').toDate(),
			})),
			buildRange(
				`Last Quarter (${formatMonthYear(lastQuarterStart)} - ${formatMonthYear(
					lastQuarterEnd
				)})`,
				() => ({
					startDate: lastQuarterStart.toDate(),
					endDate: lastQuarterEnd.toDate(),
				})
			),

			buildRange(
				`This Year (${moment(startOfYear(new Date())).format(
					'MMM,YYYY'
				)} - ${moment(new Date()).format('MMM,YYYY')})`,
				() => ({
					startDate: startOfYear(new Date()),
					endDate: endOfDay(new Date()),
				})
			),
			buildRange(
				`Last Year (${moment(moment().startOf('year'))
					.subtract(12, 'months')
					.format('MMM,YYYY')} - ${moment([lastyear])
						.endOf('year')
						.format('MMM,YYYY')})`,
				() => ({
					startDate: startOfYear(addYears(new Date(), -1)),
					endDate: endOfYear(addYears(new Date(), -1)),
				})
			),
			buildRange(
				`Last 365 Days (${moment(new Date()).subtract(12, 'months').format('MMM,YYYY')} - ${moment(new Date()).format('MMM,YYYY')})`,
				() => ({
					startDate: (() => {
						let now = new Date();
						let duedate = new Date(now);
						duedate.setDate(now.getDate() - 365);
						return duedate;
					})(),
					endDate: new Date(),
				})
			),
			buildRange(
				`Last 2 Years (${formatMonthYear(
					lastTwoYearsStart
				)} - ${formatMonthYear(today)})`,
				() => ({
					startDate: moment().subtract(24, 'months').toDate(),
					endDate: new Date(),
				})
			),
			buildRange(
				`Last 3 Years (${moment(new Date()).subtract(36, 'months').format('MMM,YYYY')} - ${moment(new Date()).format('MMM,YYYY')})`,
				() => ({
					startDate: (() => {
						let now = new Date();
						let duedate = new Date(now);
						duedate.setDate(now.getDate() - 1095);
						return duedate;
					})(),
					endDate: new Date(),
				})
			),
			buildRange(
				`Last 4 Years (${moment(new Date()).subtract(48, 'months').format('MMM,YYYY')} - ${moment(new Date()).format('MMM,YYYY')})`,
				() => ({
					startDate: (() => {
						let now = new Date();
						let duedate = new Date(now);
						duedate.setDate(now.getDate() - 1460);
						return duedate;
					})(),
					endDate: new Date(),
				})
			),
			buildRange(
				`Last 5 Years (${moment(new Date()).subtract(60, 'months').format('MMM,YYYY')} - ${moment(new Date()).format('MMM,YYYY')})`,
				() => ({
					startDate: (() => {
						let now = new Date();
						let duedate = new Date(now);
						duedate.setDate(now.getDate() - 1826);
						return duedate;
					})(),
					endDate: new Date(),
				})
			),
			buildRange(
				'Custom Range (Select Custom Date)',
				() => ({
					startDate: dateRange?.selection1?.startDate || new Date(),
					endDate: dateRange?.selection1?.endDate || new Date(),
				}),
				{ uniqueKey: 'custom_range' }
			)
		);

		if (props.showQuatreOptions) {
			const year = moment().format('YYYY');
			tempRanges.push({
				label: '',
				uniqueKey: 'all_qtr',
				range: () => ({
					startDate: moment(year, 'YYYY').startOf('year').toDate(),
					endDate: moment(year, 'YYYY').endOf('year').toDate(),
				}),
				hasCustomRendering: true,
				isSelected(range: any) {
					const definedRange: any = this.range();
					return (
						isSameDay(range.startDate, definedRange.startDate) &&
						isSameDay(range.endDate, definedRange.endDate)
					);
				},
			});
		}

		return tempRanges;
	})();

	let [dateRange, setDateRange]: any = useState({
		selection1: {
			startDate: moment().subtract(selectedDefaultMonths, 'months').toDate(),
			endDate: new Date(),
			key: 'selection1',
			label: AppUtilityFunctions.isFreemiumUser()
				? customRanges[10]?.label || 'Last 2 Years'
				: customRanges[4]?.label || 'Last 6 Months',
		},
		selection2: {
			startDate: moment()
				.subtract(selectedDefaultMonths * 2, 'months')
				.toDate(),
			endDate: moment().subtract(selectedDefaultMonths, 'months').toDate(),
			key: 'selection2',
		},
	});
	const [dateRangenew, setDateRangeNew]: any = useState({
		selection1: {
			startDate: moment().subtract(selectedDefaultMonths, 'months').toDate(),
			endDate: new Date(),
			key: 'selection1',
		},
		selection2: {
			startDate: moment()
				.subtract(selectedDefaultMonths * 2, 'months')
				.toDate(),
			endDate: moment().subtract(selectedDefaultMonths, 'months').toDate(),
			key: 'selection2',
		},
	});

	const [selectedOption, setSelectedOption]: any = useState(
		useLocalStorage.getItem('timePeriod') || 3
	);

	useEffect(() => {
		if (!isMainCustom && isCompared && Number(selectedOption) === 2) {
			setFocusedRange([1, 0]);
		} else {
			setFocusedRange([0, 0]);
		}
	}, [isMainCustom, isCompared, selectedOption]);

	const getFocusedRange = () => {
		return focusedRange;
	};

	const location = useLocation();
	const [fromBookmark, setFromBookmark] = useState(false);
	const dateRangeLocal: any = useLocalStorage.getItem('dateRange');
	const [isAllQuarter, setIsAllQuarter]: any = useState(
		dateRangeLocal?.isAllQuarter || false
	);

	const [selectedYear, setSelectedYear]: any = useState();

	useEffect(() => {
		const isFreemium = AppUtilityFunctions.isFreemiumUser();
		const defaultMonthsVal = isFreemium ? 24 : 6;
		const defaultLabelVal = isFreemium ? 'Last 2 Years' : 'Last 6 Months';

		const storedOption = useLocalStorage.getItem('timePeriod');
		if (!storedOption) {
			useLocalStorage.setItem('timePeriod', 3);
		}
		const storedLabel = useLocalStorage.getItem('dateRangeLabel');
		if (!storedLabel) {
			useLocalStorage.setItem('dateRangeLabel', defaultLabelVal);
		}
		const storedDateRange = useLocalStorage.getItem('dateRange');
		if (!storedDateRange) {
			const initialStart = moment()
				.subtract(defaultMonthsVal, 'months')
				.toDate();
			const initialEnd = new Date();
			useLocalStorage.setItem('dateRange', {
				start_date: initialStart,
				end_date: initialEnd,
			});
			useLocalStorage.setItem('compdateRange', {
				pre_start_date: moment()
					.subtract(defaultMonthsVal * 2, 'months')
					.toDate(),
				pre_end_date: initialStart,
			});
		}
		if (dateRangeLocal?.selectedYear) {
			setSelectedYear(dateRangeLocal?.selectedYear);
		} else {
			setSelectedYear(new Date().getFullYear());
		}
	}, []);

	useEffect(() => {
		if (
			location.search &&
			location.search?.split('=')[0].includes('?bookmarkId')
		) {
			setFromBookmark(true);
		}
	}, []);

	function firstDayOfWeek(dateObject: any, firstDayOfWeekIndex: any) {
		const dayOfWeek = dateObject.getDay(),
			firstDayOfWeek = new Date(dateObject),
			diff =
				dayOfWeek >= firstDayOfWeekIndex
					? dayOfWeek - firstDayOfWeekIndex
					: 6 - dayOfWeek;

		firstDayOfWeek.setDate(dateObject.getDate() - diff);
		firstDayOfWeek.setHours(0, 0, 0, 0);

		return firstDayOfWeek;
	}

	function firstDayofLastWeek(dateObject: any, firstDayOfWeekIndex: any) {
		const dayOfWeek = dateObject.getDay(),
			firstDayOfWeek = new Date(dateObject),
			diff =
				dayOfWeek >= firstDayOfWeekIndex
					? dayOfWeek - firstDayOfWeekIndex
					: 13 - dayOfWeek;

		firstDayOfWeek.setDate(dateObject.getDate() - diff);
		firstDayOfWeek.setHours(0, 0, 0, 0);

		return firstDayOfWeek;
	}
	const saveGlobalDates: any = fromBookmark
		? { start_date: props.start_date, end_date: props.end_date }
		: !props.dontSaveInLS
			? useLocalStorage.getItem('dateRange')
			: { start_date: props.start_date, end_date: props.end_date };

	// Define the function to get the start and end dates for a specific quarter.
	function getQuarterDates(quarterNumber: number, year: number) {
		const startDate = moment()
			.quarter(quarterNumber)
			.year(year)
			.startOf('quarter');
		const endDate = moment().quarter(quarterNumber).year(year).endOf('quarter');
		return { startDate, endDate };
	}

	useEffect(() => {
		setIsMultipleRange(props.isMultipleRanges);
		if (isPickerEditing.current) {
			return;
		}

		const saveGlobalDates = fromBookmark
			? { start_date: props.start_date, end_date: props.end_date }
			: useLocalStorage.getItem('dateRange');
		const saveGlobalCompDates = fromBookmark
			? {
				pre_start_date: props.pre_start_date,
				pre_end_date: props.pre_end_date,
			}
			: useLocalStorage.getItem('compdateRange');

		let activeSelection1: any;
		if (saveGlobalDates?.start_date) {
			activeSelection1 = {
				startDate: new Date(saveGlobalDates.start_date),
				endDate: new Date(saveGlobalDates.end_date),
				key: 'selection1',
			};
		} else if (props.start_date && props.end_date) {
			activeSelection1 = {
				startDate: new Date(props.start_date),
				endDate: new Date(props.end_date),
				key: 'selection1',
			};
		} else {
			activeSelection1 = {
				startDate: moment().subtract(selectedDefaultMonths, 'months').toDate(),
				endDate: new Date(),
				key: 'selection1',
			};
		}

		setDisplayDate({
			startDate: activeSelection1.startDate,
			endDate: activeSelection1.endDate,
		});
		setShownDate(activeSelection1.startDate);

		const storedOption = Number(useLocalStorage.getItem('timePeriod')) || 3;
		let activeSelection2: any;

		if (storedOption !== 2) {
			if (storedOption === 1) {
				activeSelection2 = getPreviousPeriodDate(
					activeSelection1.startDate,
					activeSelection1.endDate
				);
			} else if (storedOption === 3) {
				activeSelection2 = getPreviousYear(
					activeSelection1.startDate,
					activeSelection1.endDate
				);
			} else if (storedOption === 4) {
				activeSelection2 = getLastYear(
					moment(activeSelection1.startDate).startOf('year')
				);
			} else {
				activeSelection2 = getPreviousYear(
					activeSelection1.startDate,
					activeSelection1.endDate
				);
			}
		} else {
			if (saveGlobalCompDates?.pre_start_date) {
				const pre_dates = getPreviousPeriodDate(
					activeSelection1.startDate,
					activeSelection1.endDate
				);
				activeSelection2 = {
					startDate: new Date(
						saveGlobalCompDates.pre_start_date || pre_dates.startDate
					),
					endDate: new Date(
						saveGlobalCompDates.pre_end_date || pre_dates.endDate
					),
					key: 'selection2',
				};
			} else if (props.pre_start_date && props.pre_end_date) {
				activeSelection2 = {
					startDate: new Date(props.pre_start_date),
					endDate: new Date(props.pre_end_date),
					key: 'selection2',
				};
			} else {
				activeSelection2 = getPreviousPeriodDate(
					activeSelection1.startDate,
					activeSelection1.endDate
				);
			}
		}

		const activeDateRange = {
			selection1: activeSelection1,
			selection2: activeSelection2,
		};
		setDateRange(activeDateRange);
		setComparisonDisplayDate({
			startDate: activeSelection2.startDate,
			endDate: activeSelection2.endDate,
		});
		defaultDate.current = activeDateRange;
	}, [props.start_date, props.end_date]);
	// Events

	// var calendar = document.getElementsByClassName('ReactDateTimePicker ReactDateTimePicker__large')[0];

	// window.addEventListener('click', function (event) {
	// 	// Access the clicked element using event.target
	// 	//@ts-ignore
	// 	var isClickedInCalendar = calendar?.contains(event.target);
	// 	if (isClickedInCalendar) {
	// 		debugger;
	// 		//@ts-ignore
	// 		let clickedElement = event.target.innerText;
	// 		if (clickedElement != 'Apply') {
	// 			if (
	// 				clickedElement == 'This Week' ||
	// 				clickedElement == 'This Month' ||
	// 				clickedElement.includes('This Year') ||
	// 				clickedElement.includes('Last Year') ||
	// 				clickedElement.includes('Last 365 Days') ||
	// 				clickedElement.includes('Last 2 Years')
	// 			) {
	// 				useLocalStorage.setItem('dateRangeLabel', clickedElement);
	// 			}
	// 		}
	// 	}
	// 	return;
	// });

	const handleClose = () => {
		isPickerEditing.current = false;
		isPresetClicked.current = false;
		if (isDateApplied) {
			setIsDateApplied(false);
			setApplyButtonDisable(true);
			setAnchorEl(null);
			setIsAllQuarter(dateRangeLocal?.isAllQuarter || false);
			useLocalStorage.setItem('date_comparison', isCompared);
			setIsCompared(useLocalStorage.getItem('date_comparison'));
			return;
		}
		// useLocalStorage.setItem('date_comparison', isCompared);
		setIsCompared(useLocalStorage.getItem('date_comparison'));

		setDateRange({
			selection1: { ...displayDate, lable: customRanges, key: 'selection1' },
			selection2: { ...comparisionDisplayDate, key: 'selection2' },
		});

		// setIsDateApplied(false);
		// setApplyButtonDisable(true);
		setSelectedOption(useLocalStorage.getItem('timePeriod'));
		setAnchorEl(null);
	};
	const handleClick = (event: any) => {
		isPickerEditing.current = true;
		isPresetClicked.current = false;
		const storedOption = Number(useLocalStorage.getItem('timePeriod')) || 3;
		setSelectedOption(storedOption);
		useLocalStorage.setItem('timePeriod', storedOption);

		const mainCustom =
			useLocalStorage.getItem('isCustomRange') === true ||
			useLocalStorage.getItem('isCustomRange') === 'true';
		setIsMainCustom(mainCustom);

		const compared = useLocalStorage.getItem('date_comparison') || false;
		setIsCompared(compared);

		const saveGlobalDates = fromBookmark
			? { start_date: props.start_date, end_date: props.end_date }
			: useLocalStorage.getItem('dateRange');
		const saveGlobalCompDates = fromBookmark
			? {
				pre_start_date: props.pre_start_date,
				pre_end_date: props.pre_end_date,
			}
			: useLocalStorage.getItem('compdateRange');

		let tempDateRange = { ...dateRange };
		if (saveGlobalDates?.start_date) {
			tempDateRange.selection1 = {
				startDate: new Date(saveGlobalDates.start_date),
				endDate: new Date(saveGlobalDates.end_date),
				key: 'selection1',
			};
			setDisplayDate({
				startDate: new Date(saveGlobalDates.start_date),
				endDate: new Date(saveGlobalDates.end_date),
			});
		}
		if (saveGlobalCompDates?.pre_start_date) {
			tempDateRange.selection2 = {
				startDate: new Date(saveGlobalCompDates.pre_start_date),
				endDate: new Date(saveGlobalCompDates.pre_end_date),
				key: 'selection2',
			};
			setComparisonDisplayDate({
				startDate: new Date(saveGlobalCompDates.pre_start_date),
				endDate: new Date(saveGlobalCompDates.pre_end_date),
			});
		}
		setDateRange(tempDateRange);
		setShownDate(tempDateRange.selection1.startDate);

		setShowSideCalendar(
			mainCustom || !!(compared && isMultipleRange && storedOption === 2)
		);
		if (mainCustom) {
			setFocusedRange([0, 0]);
		}
		setApplyButtonDisable(true);
		setAnchorEl(event.currentTarget);
	};

	useEffect(() => {
		isDateApplied ? handleClose() : <></>;
	}, [isDateApplied]);

	const getPreviousPeriodDate = (start: any, end: any) => {
		const tempStart: any = new Date(DateTimeFormatter.getDateInFormat(start));
		const tempEnd: any = new Date(DateTimeFormatter.getDateInFormat(end));
		const diffTime = Math.abs(tempEnd - tempStart);
		const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
		const prevStart = moment(start)
			.subtract(diffDays + 1, 'days')
			.toDate();
		const prevEnd = moment(start).subtract(1, 'days').toDate();
		return {
			startDate: prevStart,
			endDate: prevEnd,
			key: 'selection2',
		};
	};
	const getPreviousYear = (start: any, end: any) => {
		const prevStart = moment(start).subtract(12, 'months').toDate();
		const prevEnd = moment(end).subtract(12, 'months').toDate();
		return {
			startDate: prevStart,
			endDate: prevEnd,
			key: 'selection2',
		};
	};
	const getSelectionToSave = () => {
		if (isCompared && Number(selectedOption) === 2) {
			return dateRange.selection2;
		}

		if (Number(selectedOption) === 1) {
			return getPreviousPeriodDate(
				dateRange.selection1.startDate,
				dateRange.selection1.endDate
			);
		}

		if (Number(selectedOption) === 4) {
			return getLastYear(
				moment(dateRange.selection1.startDate).startOf('year')
			);
		}

		return getPreviousYear(
			dateRange.selection1.startDate,
			dateRange.selection1.endDate
		);
	};
	var lastyear: any = new Date(
		new Date().getFullYear() - 1,
		0,
		1
	).getFullYear();

	const getLastYear = (start = moment().startOf('year')) => {
		const yearDifference = Math.abs(selectedYear - new Date().getFullYear());
		const subtractionMonth = yearDifference == 0 ? 12 : 24;
		var preStart = moment(start)
			.subtract(Math.abs(subtractionMonth), 'months')
			.toDate(),
			end = moment([yearDifference == 0 ? lastyear : lastyear - 1])
				.endOf('year')
				.toDate();
		return {
			startDate: preStart,
			endDate: end,
			key: 'selection2',
		};
	};
	const onOptionSelection = (evt: any) => {
		setApplyButtonDisable(false);
		const val = evt.target.value;
		const isCompareCustom = val === 2;

		if (showSideCalendar) {
			setShowSideCalendar(true);
		} else {
			setShowSideCalendar(isCompareCustom);
		}

		if (val === 1) {
			setDateRange({
				selection1: {
					startDate: dateRange.selection1.startDate,
					endDate: dateRange.selection1.endDate,
					key: 'selection1',
				},
				selection2: getPreviousPeriodDate(
					dateRange.selection1.startDate,
					dateRange.selection1.endDate
				),
			});
			forMetricReportComp = 'prev_period';
		} else if (val === 3) {
			setDateRange({
				selection1: {
					startDate: dateRange.selection1.startDate,
					endDate: dateRange.selection1.endDate,
					key: 'selection1',
				},
				selection2: getPreviousYear(
					dateRange.selection1.startDate,
					dateRange.selection1.endDate
				),
			});
			forMetricReportComp = 'same_period';
		} else if (val === 4) {
			setDateRange({
				selection1: {
					startDate: dateRange.selection1.startDate,
					endDate: dateRange.selection1.endDate,
					key: 'selection1',
				},
				selection2: getLastYear(),
			});
			forMetricReportComp = 'prev_year';
		} else {
			forMetricReportComp = 'custom_compare';
			setShowSideCalendar(true);
		}

		setForMetricReportComp(forMetricReportComp);
		setSelectedOption(val);
	};

	const [allQtrColor, setAllQtrColor]: any = useState(
		theme.palette.mode === 'dark' ? 'white' : 'black'
	);

	// build

	const handleRanges = (range: any): any => {
		let dateRangeObj: any;
		try {
			const first: any = range?.label?.split('(');
			/* if (range.uniqueKey == 'compare_control') {
				return (
					<div
						className='ReactDateTimePicker__compareControl'
						onClick={(evt: any) => evt.stopPropagation()}
					>
						<FormGroup>
							<FormControlLabel
								control={
									<Checkbox
										checked={isCompared}
										onChange={(evt: any) => {
											setIsCompared(evt.target.checked);
											if (!evt.target.checked) {
												if (!isMainCustom) {
													setShowSideCalendar(false);
												}
											}
											setApplyButtonDisable(false);
										}}
										size='small'
										icon={<RadioButtonUncheckedIcon />}
										checkedIcon={<CheckCircleIcon />}
									/>
								}
								label={isMultipleRange ? 'Compare With' : 'Compare % change'}
							/>
						</FormGroup>
						{isMultipleRange && isCompared ? (
							<div className='ReactDateTimePicker__compareDropdown'>
								<Dropdown
									paperClass='ReactDateTimePicker__dropdownPaper'
									disabled={!isCompared}
									valueSelector='value'
									itemList={[
										{
											name: 'Same Period Previous Year',
											value: 3,
										},
										{
											name: 'Previous Period',
											value: 1,
										},
										{
											name: 'Previous Year',
											value: 4,
										},
										{
											name: 'Custom',
											value: 2,
										},
									]}
									label='name'
									selectedValue={selectedOption}
									name='Type'
									labelName='Select'
									showTootip={true}
									charActorLength={15}
									onChange={(evt: any) => onOptionSelection(evt)}
								/>
							</div>
						) : null}
					</div>
				);
			} */
			return (
				<>
					<div
						className={`${range.uniqueKey == 'all_qtr'
							? 'ReactDateTimePicker__allQtrContainer'
							: ''
							} ${props.showQuatreOptions ? 'quatre-enabled' : ''}`}
						style={{
							display: 'flex',
							flexDirection: 'column',
							gap: '5px',
							padding: props.showQuatreOptions ? '10px 20px' : '',
							alignItems: 'start',
						}}
						onClick={(evt: any) => {
							evt.stopPropagation();
							if (range.uniqueKey == 'custom_range') {
								isPresetClicked.current = false;
								setIsMainCustom(true);
								setShowSideCalendar(true);
								setFocusedRange([0, 0]);
								setShownDate(dateRange.selection1.startDate);
								return;
							}
							isPresetClicked.current = true;
							if (range.uniqueKey == 'all_qtr' && !dateRangeObj) {
								setIsMainCustom(false);
								if (!isCompared || Number(selectedOption) !== 2) {
									setShowSideCalendar(false);
								}
								setAllQtrColor(
									theme.palette.mode === 'dark' ? 'white' : 'black'
								);
								let yearDifference = new Date().getFullYear() - selectedYear;
								const newDate = new Date();
								const firstDateOfYear = new Date(newDate.getFullYear(), 0, 1);
								let lastYearDate: any = new Date(firstDateOfYear);
								lastYearDate.setFullYear(
									firstDateOfYear.getFullYear() - yearDifference
								);
								let yearLast1: any;
								if (yearDifference > 0) {
									yearLast1 = new Date(new Date().getFullYear() - 1, 11, 31);
								} else {
									yearLast1 = new Date(new Date().getFullYear(), 11, 31);
								}
								let newObject = {
									startDate: lastYearDate,
									endDate: yearLast1,
									key: 'selection1',
								};
								let tempDateRange = { ...dateRange };
								tempDateRange.selection1 = newObject;
								if (isCompared && Number(selectedOption) !== 2) {
									if (Number(selectedOption) === 1) {
										tempDateRange.selection2 = getPreviousPeriodDate(
											tempDateRange.selection1.startDate,
											tempDateRange.selection1.endDate
										);
									} else if (Number(selectedOption) === 3) {
										tempDateRange.selection2 = getPreviousYear(
											tempDateRange.selection1.startDate,
											tempDateRange.selection1.endDate
										);
									} else if (Number(selectedOption) === 4) {
										tempDateRange.selection2 = getLastYear(
											moment(tempDateRange.selection1.startDate).startOf('year')
										);
									}
								}
								setApplyButtonDisable(false);
								setTimeout(() => {
									setDateRange(tempDateRange);
									// setIsPreviousYear(true);
									setDateRangeNew(tempDateRange);
									setIsAllQuarter(true);
									isPresetClicked.current = false;
								}, 0);
							}
						}}
					// style={{ }}
					>
						{range.uniqueKey == 'all_qtr' ? (
							<>
								{' '}
								<div
									className='allqtrDropDown'
									style={{
										color: allQtrColor,
										whiteSpace: 'nowrap',
										marginLeft: '5px',
									}}
								>
									All Qtr.
								</div>
								<div
									style={{ width: '110px' }}
									onClick={(e) => e.stopPropagation()}
								>
									<Dropdown
										paperClass='ReactDateTimePicker__dropdownPaper'
										valueSelector='value'
										itemList={[
											{
												name: 'CY ' + '(' + new Date().getFullYear() + ')',
												value: new Date().getFullYear(),
											},
											{
												name:
													'PY ' + '(' + (new Date().getFullYear() - 1) + ')',
												value: new Date().getFullYear() - 1,
											},
										]}
										label='name'
										selectedValue={selectedYear}
										name='Type'
										// labelName='Select'
										onChange={(e: any) => {
											isPresetClicked.current = true;
											// setIsAllQuarter(false);
											setAllQtrColor(
												theme.palette.mode === 'dark' ? 'white' : 'black'
											);
											let yearDifference =
												new Date().getFullYear() - Number(e.target.value);
											const newDate = new Date();
											const firstDateOfYear = new Date(
												newDate.getFullYear(),
												0,
												1
											);
											let lastYearDate: any = new Date(firstDateOfYear);
											lastYearDate.setFullYear(
												firstDateOfYear.getFullYear() - yearDifference
											);
											let yearLast1: any;
											if (yearDifference > 0) {
												yearLast1 = new Date(
													new Date().getFullYear() - 1,
													11,
													31
												);
											} else {
												yearLast1 = new Date(new Date().getFullYear(), 11, 31);
											}

											// yearLast1.setFullYear(firstDateOfYear.getFullYear());
											let newObject = {
												startDate: lastYearDate,
												endDate: yearLast1,
												key: 'selection1',
											};
											let tempDateRange = { ...dateRange };
											tempDateRange.selection1 = newObject;
											if (isCompared && Number(selectedOption) !== 2) {
												if (Number(selectedOption) === 1) {
													tempDateRange.selection2 = getPreviousPeriodDate(
														tempDateRange.selection1.startDate,
														tempDateRange.selection1.endDate
													);
												} else if (Number(selectedOption) === 3) {
													tempDateRange.selection2 = getPreviousYear(
														tempDateRange.selection1.startDate,
														tempDateRange.selection1.endDate
													);
												} else if (Number(selectedOption) === 4) {
													tempDateRange.selection2 = getLastYear(
														moment(tempDateRange.selection1.startDate).startOf(
															'year'
														)
													);
												}
											}
											dateRangeObj = tempDateRange;
											setApplyButtonDisable(false);
											setTimeout(() => {
												setDateRange(tempDateRange);
												setIsPreviousYear(true);
												setDateRangeNew(tempDateRange);
												setIsAllQuarter(true);
												if (!isCompared || Number(selectedOption) !== 2) {
													setShowSideCalendar(false);
												}
												isPresetClicked.current = false;
											}, 0);
											setSelectedYear(Number(e.target.value));
										}}
									/>
								</div>
							</>
						) : (
							<div
								className='ReactDateTimePicker__rangeLabelTextContainer'
								onClick={(evt: any) => {
									evt.stopPropagation();
									if (range.uniqueKey == 'custom_range') {
										isPresetClicked.current = false;
										setIsMainCustom(true);
										setShowSideCalendar(true);
										setFocusedRange([0, 0]);
										setShownDate(dateRange.selection1.startDate);
										return;
									}
									isPresetClicked.current = true;
									setIsMainCustom(false);
									if (!isCompared || Number(selectedOption) !== 2) {
										setShowSideCalendar(false);
									}
									setAllQtrColor(
										theme.palette.mode === 'dark' ? 'white' : 'black'
									);
									setIsAllQuarter(false);
									setSelectedYear(new Date().getFullYear());

									const definedRange = range.range();
									let tempDateRange = { ...dateRange };
									tempDateRange.selection1 = {
										...tempDateRange.selection1,
										startDate: definedRange.startDate,
										endDate: definedRange.endDate,
									};
									if (isCompared && Number(selectedOption) !== 2) {
										if (Number(selectedOption) === 1) {
											tempDateRange.selection2 = getPreviousPeriodDate(
												tempDateRange.selection1.startDate,
												tempDateRange.selection1.endDate
											);
										} else if (Number(selectedOption) === 3) {
											tempDateRange.selection2 = getPreviousYear(
												tempDateRange.selection1.startDate,
												tempDateRange.selection1.endDate
											);
										} else if (Number(selectedOption) === 4) {
											tempDateRange.selection2 = getLastYear(
												moment(tempDateRange.selection1.startDate).startOf(
													'year'
												)
											);
										}
									}
									setDateRange(tempDateRange);
									setApplyButtonDisable(false);
									setTimeout(() => {
										isPresetClicked.current = false;
									}, 0);
								}}
							>
								<div className='ReactDateTimePicker__rangeLabelTextMain'>
									{range.label.split('(')[0].trim()}
								</div>
								{range.label.includes('(') && (
									<div className='ReactDateTimePicker__rangeLabelTextSub'>
										{range.label.split('(')[1].replace(')', '').trim()}
									</div>
								)}
							</div>
						)}
					</div>
					{/* {props.showQuatreOptions ? (
						<style>{`
			.rdrStaticRangeLabel:has(> div){
				padding: 0 !important;
			}
		`}</style>
					) : (
						<></>
					)} */}
				</>
			);
		} catch (error: any) {
			alert(error);
		}
	};
	const data = {
		fill: theme.palette.text.tertiary,
		width: '20px',
		height: '20px',
	};

	const handlingMonthandYear = (data: any) => {
		let originalDate = new Date(data);

		// Get the month name abbreviation
		let monthNames = [
			'Jan',
			'Feb',
			'Mar',
			'Apr',
			'May',
			'Jun',
			'Jul',
			'Aug',
			'Sep',
			'Oct',
			'Nov',
			'Dec',
		];
		let monthAbbreviation = monthNames[originalDate.getMonth()];

		// Get the year
		let year = originalDate.getFullYear();

		// Format the date as "Month, Year"
		let formattedDate = monthAbbreviation + ', ' + year;
		return formattedDate;
	};

	const checkWhichLabeltoSave = (data: any) => {
		let now = new Date();
		let duedate = new Date(now);
		const currentQuarterStart = moment().startOf('quarter');
		const currentQuarterEnd = moment().endOf('quarter');
		const year = moment().format('YYYY');

		const previousQuarterStart = moment()
			.startOf('quarter')
			.subtract(3, 'months');
		const previousQuarterEnd = moment().endOf('quarter').subtract(3, 'months');

		if (
			data.startDate ==
			DateTimeFormatter.getDateInFormat(firstDayOfWeek(new Date(), 0)) &&
			data.endDate == DateTimeFormatter.getDateInFormat(new Date())
		) {
			// --------------------------------This week-----------------------------------
			return `(${DateTimeFormatter.getDateInFormat(
				data.startDate
			)} - ${DateTimeFormatter.getDateInFormat(data.endDate)})`;
		}

		if (
			data.startDate ==
			DateTimeFormatter.getDateInFormat(
				new Date(new Date().getFullYear(), new Date().getMonth(), 1)
			) &&
			data.endDate == DateTimeFormatter.getDateInFormat(new Date())
		) {
			//--------------------------This month--------------------------------
			return `(${DateTimeFormatter.getDateInFormat(
				data.startDate
			)} - ${DateTimeFormatter.getDateInFormat(data.endDate)})`;
		}

		if (
			data.startDate ==
			DateTimeFormatter.getDateInFormat(startOfYear(new Date())) &&
			data.endDate == DateTimeFormatter.getDateInFormat(endOfDay(new Date()))
		) {
			//--------------------------This year--------------------------------
			return `(${DateTimeFormatter.getDateInFormat(
				data.startDate
			)} - ${DateTimeFormatter.getDateInFormat(data.endDate)})`;
		}

		if (
			data.startDate ==
			DateTimeFormatter.getDateInFormat(
				startOfYear(addYears(new Date(), -1))
			) &&
			data.endDate ==
			DateTimeFormatter.getDateInFormat(endOfYear(addYears(new Date(), -1)))
		) {
			//--------------------------Last year--------------------------------
			return `(${DateTimeFormatter.getDateInFormat(
				data.startDate
			)} - ${DateTimeFormatter.getDateInFormat(data.endDate)})`;
		}

		if (
			data.startDate ==
			DateTimeFormatter.getDateInFormat(
				new Date(now.getFullYear(), now.getMonth(), now.getDate() - 365)
			) &&
			data.endDate == DateTimeFormatter.getDateInFormat(new Date())
		) {
			//--------------------------Last 365 Days--------------------------------
			return `(${DateTimeFormatter.getDateInFormat(
				data.startDate
			)} - ${DateTimeFormatter.getDateInFormat(data.endDate)})`;
		}

		if (
			data.startDate ==
			DateTimeFormatter.getDateInFormat(
				new Date(now.getFullYear(), now.getMonth(), now.getDate() - 730)
			) &&
			data.endDate == DateTimeFormatter.getDateInFormat(new Date())
		) {
			//--------------------------Last 2 Years--------------------------------
			return ` (${DateTimeFormatter.getDateInFormat(
				data.startDate
			)} - ${DateTimeFormatter.getDateInFormat(data.endDate)})`;
		}

		if (
			data.startDate ==
			DateTimeFormatter.getDateInFormat(currentQuarterStart.toDate()) &&
			data.endDate ==
			DateTimeFormatter.getDateInFormat(currentQuarterEnd.toDate())
		) {
			//--------------------------Current Quarter--------------------------------
			return `(${DateTimeFormatter.getDateInFormat(
				data.startDate
			)} - ${DateTimeFormatter.getDateInFormat(data.endDate)})`;
		}

		if (
			data.startDate ==
			DateTimeFormatter.getDateInFormat(previousQuarterStart.toDate()) &&
			data.endDate ==
			DateTimeFormatter.getDateInFormat(previousQuarterEnd.toDate())
		) {
			//--------------------------Previous Quarter--------------------------------
			return `(${DateTimeFormatter.getDateInFormat(
				data.startDate
			)} - ${DateTimeFormatter.getDateInFormat(data.endDate)})`;
		}

		if (
			data.startDate ==
			DateTimeFormatter.getDateInFormat(
				moment(year, 'YYYY').startOf('year').toDate()
			) &&
			data.endDate ==
			DateTimeFormatter.getDateInFormat(
				moment(year, 'YYYY').endOf('year').toDate()
			)
		) {
			//--------------------------All Quarters or Current Year--------------------------------
			return `All Qtr (${DateTimeFormatter.getDateInFormat(
				data.startDate
			)} - ${DateTimeFormatter.getDateInFormat(data.endDate)})`;
		} else {
			return `${data.startDate + ' - ' + data.endDate}`;
		}
	};

	return (
		<div
			className={`ReactDateTimePicker ReactDateTimePicker__large`}
			style={theme.palette.reactFilterCalenderStyle}
		>
			<Grid
				container
				style={
					useLocalStorage.getItem('date_comparison') && isMultipleRange
						? { width: '16rem' }
						: { width: 'fit-content' }
				}
				className='ReactDateTimePicker__displayLabel'
				onClick={handleClick}
			>
				<Grid item xs={2}>
					<IconButton style={{ marginTop: '2px' }}>
						{/* <img src={CalendarIcon} alt='Calendar Icon' /> */}
						<img src={CalendarIcon} alt='Calendar Icon' style={data} />
					</IconButton>
				</Grid>
				<Grid
					item
					xs={10}
					style={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
					}}
				>
					<Typography
						sx={{
							fontSize: `${theme.typography?.calenderFont?.font || '14px'} !important`,
						}}
					>
						<b>
							{`${DateTimeFormatter.getDateInFormat(
								displayDate.startDate,
								format
							)} - ${DateTimeFormatter.getDateInFormat(
								displayDate.endDate,
								format
							)}`}
						</b>
					</Typography>
					{useLocalStorage.getItem('date_comparison') && isMultipleRange ? (
						<Typography
							className='ReactDateTimePicker__compareRange'
							sx={{
								fontSize: `${theme.typography?.calenderFont?.compareFont || '12px'} !important`,
							}}
						>
							Compare to:
							{` ${DateTimeFormatter.getDateInFormat(
								comparisionDisplayDate.startDate ||
								dateRange.selection2.startDate,
								format
							)} - ${DateTimeFormatter.getDateInFormat(
								comparisionDisplayDate.endDate || dateRange.selection2.endDate,
								format
							)}`}
						</Typography>
					) : null}
				</Grid>
			</Grid>
			<Menu
				id='basic-menu'
				className={`ReactDateTimePicker__menu ${theme.palette.mode === 'dark'
					? 'ReactDateTimePicker__menu--dark'
					: 'ReactDateTimePicker__menu--light'
					} ${showSideCalendar
						? 'ReactDateTimePicker__menu--calendarOpen'
						: 'ReactDateTimePicker__menu--calendarClosed'
					}`}
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				transformOrigin={{ horizontal: 'right', vertical: 'top' }}
				anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
				classes={{
					root: 'ReactDateTimePicker__paper',
				}}
			// MenuListProps
			>
				<DateRangePicker
					onChange={(item: any) => {
						if (isPresetClicked.current) {
							isPresetClicked.current = false;
							return;
						}
						if (
							item?.selection1?.isCustomRangeSelection ||
							item?.selection2?.isCustomRangeSelection
						) {
							setIsMainCustom(true);
							setShowSideCalendar(true);
							return;
						}
						if (isAllQuarter == true) {
							setIsAllQuarter(false);
							setAllQtrColor(theme.palette.mode === 'dark' ? 'white' : 'black');
						}

						let cleanItem = { ...item };
						// Lock upper row only when comparison option is Custom (2)
						if (isMainCustom && isCompared && Number(selectedOption) === 2) {
							// If both are custom, enable both by not deleting either selection
						} else {
							if (
								!isMainCustom ||
								(isCompared && Number(selectedOption) === 2)
							) {
								delete cleanItem.selection1;
							}
							if (!isCompared || Number(selectedOption) !== 2) {
								delete cleanItem.selection2;
							}
						}
						if (Object.keys(cleanItem).length === 0) {
							return;
						}

						const nextDateRange = {
							selection1: { ...dateRange.selection1 },
							selection2: { ...dateRange.selection2 },
						};
						const focusedSelectionKey = `selection${focusedRange[0] + 1}`;
						if (cleanItem?.[focusedSelectionKey]?.startDate) {
							setShownDate(cleanItem[focusedSelectionKey].startDate);
						}

						if (
							cleanItem?.selection1 &&
							DateTimeFormatter.checkIfDateBefore(
								cleanItem.selection1.startDate,
								new Date(oneYear(minYear))
							)
						) {
							nextDateRange.selection1.startDate = new Date(oneYear(minYear));
							nextDateRange.selection1.endDate = new Date();
						} else if (
							cleanItem?.selection1 &&
							DateTimeFormatter.checkIfDateBefore(
								cleanItem.selection1.endDate,
								new Date(oneYear(minYear))
							)
						) {
							nextDateRange.selection1.startDate = new Date(oneYear(minYear));
							nextDateRange.selection1.endDate = new Date();
						} else if (
							cleanItem?.selection2 &&
							DateTimeFormatter.checkIfDateBefore(
								cleanItem.selection2.startDate,
								new Date(oneYear(minYear))
							)
						) {
							nextDateRange.selection2.startDate = new Date(oneYear(minYear));
							nextDateRange.selection2.endDate = new Date();
						} else if (
							cleanItem?.selection2 &&
							DateTimeFormatter.checkIfDateBefore(
								cleanItem.selection2.startDate,
								new Date(oneYear(minYear))
							)
						) {
							nextDateRange.selection2.startDate = new Date(oneYear(minYear));
							nextDateRange.selection2.endDate = new Date();
						} else {
							Object.assign(nextDateRange, cleanItem);
						}
						setApplyButtonDisable(false);
						setDateRange(nextDateRange);
					}}
					editableDateInputs={false}
					// maxDate={yesterday}
					maxDate={new Date()}
					minDate={new Date(oneYear(minYear))}
					moveRangeOnFirstSelection={false}
					months={showSideCalendar || isMultipleRange ? 2 : 1}
					renderStaticRangeLabel={handleRanges}
					direction='horizontal'
					rangeColors={['#E600FF', '#9646FF']}
					staticRanges={customRanges}
					startDatePlaceholder={'Start Date'}
					endDatePlaceholder={'End Date'}
					ranges={
						isCompared == true && props?.showComparison
							? [{ ...dateRange.selection1 }, { ...dateRange.selection2 }]
							: [{ ...dateRange.selection1 }]
					}
					focusedRange={getFocusedRange()}
					onRangeFocusChange={(range: any) => {
						if (isMainCustom && isCompared && Number(selectedOption) === 2) {
							setFocusedRange(range);
						} else if (isCompared && Number(selectedOption) === 2) {
							setFocusedRange([1, range[1]]);
						} else if (isMainCustom) {
							setFocusedRange([0, range[1]]);
						}
					}}
					inputRanges={inputRange}
					className={`${theme.palette.mode === 'dark'
						? 'ReactFilterDateRangePickerDark'
						: 'ReactFilterDateRangePicker'
						} ${showSideCalendar
							? 'ReactFilterDateRangePicker--calendarOpen'
							: 'ReactFilterDateRangePicker--calendarClosed'
						} ${isMainCustom && isCompared && Number(selectedOption) === 2
							? ''
							: !isMainCustom || (isCompared && Number(selectedOption) === 2)
								? 'ReactFilterDateRangePicker--mainDisabled'
								: ''
						} ${isCompared && Number(selectedOption) !== 2
							? 'ReactFilterDateRangePicker--compareDisabled'
							: ''
						} ${!isMainCustom && (!isCompared || Number(selectedOption) !== 2)
							? 'ReactFilterDateRangePicker--calendarDisabled'
							: ''
						}`}
				/>
				<div>
					<div className='ReactDateTimePicker__button'>
						{/* (props.showCustomComponent || props.isMultipleRanges) && (
							<div
								className='ReactDateTimePicker__compareControlBottom'
								onClick={(evt: any) => evt.stopPropagation()}
							>
								<FormGroup>
									<FormControlLabel
										control={
											<Checkbox
												checked={isCompared}
												onChange={(evt: any) => {
													setIsCompared(evt.target.checked);
													if (!evt.target.checked) {
														if (!isMainCustom) {
															setShowSideCalendar(false);
														}
													} else {
														if (selectedOption === 2) {
															setShowSideCalendar(true);
														}
													}
													setApplyButtonDisable(false);
												}}
												size='small'
												icon={<RadioButtonUncheckedIcon />}
												checkedIcon={<CheckCircleIcon />}
											/>
										}
										label={
											isMultipleRange ? 'Compare With' : 'Compare % change'
										}
									/>
								</FormGroup>
								{isMultipleRange && isCompared ? (
									<div className='ReactDateTimePicker__compareDropdown'>
										<Dropdown
											paperClass='ReactDateTimePicker__dropdownPaper'
											disabled={!isCompared}
											valueSelector='value'
											itemList={[
												{
													name: 'Same Period Previous Year',
													value: 3,
												},
												{
													name: 'Previous Period',
													value: 1,
												},
												{
													name: 'Previous Year',
													value: 4,
												},
												{
													name: 'Custom',
													value: 2,
												},
											]}
											label='name'
											selectedValue={selectedOption}
											name='Type'
											labelName='Select'
											showTootip={true}
											charActorLength={15}
											onChange={(evt: any) => onOptionSelection(evt)}
										/>
									</div>
								) : null}
							</div>
						) */}
						<div className='ReactDateTimePicker__actionButtons'>
							<Button
								btnText='Cancel'
								type='button'
								variant='outlined'
								onClick={handleClose}
							/>
							<Button
								btnText='Apply'
								type='button'
								disable={applyButtonDisable}
								onClick={(evt: any) => {
									const comparisonSelectionToSave = getSelectionToSave();
									const dateRangeToApply = {
										...dateRange,
										selection2: comparisonSelectionToSave,
									};
									saveDateForLabel = {
										startDate: DateTimeFormatter.getDateInFormat(
											dateRange.selection1.startDate
										),
										endDate: DateTimeFormatter.getDateInFormat(
											dateRange.selection1.endDate
										),
									};
									setSaveDateforLabel(saveDateForLabel);
									let DateRangeLabel = checkWhichLabeltoSave(saveDateForLabel);
									useLocalStorage.setItem('dateRangeLabel', DateRangeLabel);
									setIsDateApplied(true);
									useLocalStorage.setItem('isCustomRange', isMainCustom);
									useLocalStorage.setItem('date_comparison', isCompared);
									useLocalStorage.setItem('CompType', forMetricReportComp);
									!props.showComparison ? '' : props?.onCompareChange(evt);
									!props.showCustomComponent ? '' : props?.onCompareChange(evt);

									if (isMultipleRange) {
										props?.onChange(dateRangeToApply, isAllQuarter);
									} else {
										props?.onChange(
											{
												startDate: DateTimeFormatter.getDateInFormat(
													dateRange.selection1.startDate
												),
												endDate: DateTimeFormatter.getDateInFormat(
													dateRange.selection1.endDate
												),
											},
											isAllQuarter
										);
									}
									if (
										!(
											location.search &&
											location.search?.split('=')[0].includes('?bookmarkId')
										)
									) {
										useLocalStorage.setItem('dateRanges', {
											start_date: DateTimeFormatter.getDateInFormat(
												dateRange.selection1.startDate
											),
											end_date: DateTimeFormatter.getDateInFormat(
												dateRange.selection1.endDate
											),
											pre_start_date: DateTimeFormatter.getDateInFormat(
												comparisonSelectionToSave.startDate
											),
											pre_end_date: DateTimeFormatter.getDateInFormat(
												comparisonSelectionToSave.endDate
											),
										});
										useLocalStorage.setItem('dateRange', {
											start_date: dateRange.selection1.startDate,
											end_date: dateRange.selection1.endDate,
											isAllQuarter: isAllQuarter,
											selectedYear: selectedYear,
										});

										if (props?.showQuatreOptions) {
											props.isShowQuarter(isAllQuarter);
										}
										if (isMultipleRange) {
											useLocalStorage.setItem('compdateRange', {
												pre_start_date: comparisonSelectionToSave.startDate,
												pre_end_date: comparisonSelectionToSave.endDate,
											});
										}
									}
									if (isMultipleRange) {
										setComparisonDisplayDate({ ...comparisonSelectionToSave });
										setDateRange(dateRangeToApply);
										if (isCompared) {
											useLocalStorage.setItem('timePeriod', selectedOption);
										} else {
											useLocalStorage.setItem('timePeriod', 3);
											setSelectedOption(3);
										}
									}
									// debugger
									let contextDate = {
										start_date: DateTimeFormatter.getDateInFormat(
											dateRange.selection1.startDate
										),
										end_date: DateTimeFormatter.getDateInFormat(
											dateRange.selection1.endDate
										),
										pre_start_date: DateTimeFormatter.getDateInFormat(
											comparisonSelectionToSave.startDate
										),
										pre_end_date: DateTimeFormatter.getDateInFormat(
											comparisonSelectionToSave.endDate
										),
									};

									if (setDateRangeContext) setDateRangeContext({ ...contextDate });
									setDisplayDate({ ...dateRange.selection1 });
									setApplyButtonDisable(true);
									// handleClose();
								}}
							/>
						</div>
					</div>
				</div>
			</Menu>
		</div>
	);
	function oneYear(num: number) {
		const d = new Date();
		d.setFullYear(d.getFullYear() - num);
		return d;
	}
};

export default ReactDatePicker;
